<template>
  <div class="official-model">
    <!-- 顶部导航 -->
    <Headers />

    <!-- 页面内容区域 -->
    <div class="page-content">
      <!-- 模型推荐区域 -->
      <section class="models-section" ref="modelsSection">
        <div class="models-container">
          <!-- 热门模型 -->
          <div class="model-category">
            <div class="category-header">
              <h3 style="color: #FFFFFF;">
                <i class="el-icon-star-on xc-icon"></i>
                热门模型
              </h3>
           <span class="category-desc">最受欢迎的AI模型</span>
            </div>
            <div class="model-grid">
              <model-card
                v-for="model in hotModels"
                :key="model.id"
                :model="model"
                :category="'hot'"
                @click="viewModel"
              />
            </div>
          </div>

          <!-- 飙升模型 -->
          <div class="model-category">
            <div class="category-header">
              <h3 style="color: #FFFFFF;">
                <i class="el-icon-top xc-icon"></i>
                飙升模型
              </h3>
              <span class="category-desc">使用量快速增长的模型</span>
            </div>
            <div class="model-grid">
              <model-card
                v-for="model in trendingModels"
                :key="model.id"
                :model="model"
                :category="'trending'"
                @click="viewModel"
              />
            </div>
          </div>

          <!-- 潜力模型 -->
          <div class="model-category">
            <div class="category-header">
              <h3 style="color: #FFFFFF;">
                <i class="el-icon-magic-stick xc-icon"></i>
                潜力模型
              </h3>
              <span class="category-desc">新兴且具有潜力的模型</span>
            </div>
            <div class="model-grid">
              <model-card
                v-for="model in potentialModels"
                :key="model.id"
                :model="model"
                :category="'potential'"
                @click="viewModel"
              />
            </div>
          </div>
        </div>
      </section>

      <!-- CTA区域 -->
      <section class="cta-section">
        <div class="cta-container">
          <h2>准备开始您的AI项目？</h2>
          <p>选择适合的产品方案，立即开始体验</p>
          <div class="cta-actions">
            <button class="main-btn main-btn-small sm2" @click="goToRegister">
              <a href="#" >免费注册</a>
            </button>
            <button class="main-btn main-btn-small sm2" @click="goToPricing">
              <a href="#" >查看定价</a>
            </button>
          </div>
        </div>
      </section>
    </div>

    <Footer />
  </div>
</template>

<script>
import { getHotModels, getTrendingModels, getPotentialModels } from '@/api/compute-platform'
import Headers from '@/components/headers.vue'
import Footer from '@/components/footer.vue'
export default {
  name: 'OfficialModel',
  components: {
    Headers,
    Footer
  },
  data () {
    return {
      isScrolled: false,
      hotModels: [],
      trendingModels: [],
      potentialModels: [],
      loading: false
    }
  },
  async created () {
    await this.loadModels()
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    async loadModels () {
      this.loading = true
      try {
        const [hotRes, trendingRes, potentialRes] = await Promise.all([
          getHotModels({ limit: 6 }),
          getTrendingModels({ limit: 6 }),
          getPotentialModels({ limit: 6 })
        ])

        this.hotModels = hotRes.data || []
        this.trendingModels = trendingRes.data || []
        this.potentialModels = potentialRes.data || []
      } catch (error) {
        console.error('加载模型数据失败:', error)
        this.$message.error('加载模型数据失败')
      } finally {
        this.loading = false
      }
    },
    goToRegister() {
      window.open('/login', '_blank')
    },
    goToPricing () {
      this.$router.push('/official/pricing')
    },
    scrollToModels () {
      this.$refs.modelsSection.scrollIntoView({ behavior: 'smooth' })
    },
    viewModel (model) {
      // 跳转到模型详情或启动页面
      this.$router.push({
        path: '/compute-market',
        query: { modelId: model.id }
      })
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 10
    }
  }
}
</script>

<style lang="scss" scoped>
.official-model {
  min-height: 100vh;
  background: #0d0d12;
  color: #ffffff;
}

// 头部导航

// 页面内容
.page-content {
  padding-top: 70px;
}

// 模型推荐区域
.models-section {
  padding: 80px 20px;

  .models-container {
    max-width: 1200px;
    margin: 0 auto;
  }

  .model-category {
    margin-bottom: 60px;

    &:last-child {
      margin-bottom: 0;
    }

    .category-header {
      text-align: center;
      margin-bottom: 40px;

      h3 {
        font-size: 32px;
        margin: 0 0 8px;
        font-weight: 600;

        i {
          margin-right: 12px;
          color: #667eea;
        }
      }

      .category-desc {
        color: #fff;
        font-size: 16px;
      }
    }

    .model-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
      gap: 24px;
    }
  }
}

// CTA区域
.cta-section {
  padding: 100px 20px;
  background: #000;
  text-align: center;

  .cta-container {
    max-width: 800px;
    margin: 0 auto;

    h2 {
      font-size: 36px;
      font-weight: 700;
      color: white;
      margin: 0 0 16px;
    }

    p {
      font-size: 18px;
      color: rgba(255, 255, 255, 0.9);
      margin: 0 0 40px;
    }

    .cta-actions {
      display: flex;
      justify-content: center;
      gap: 20px;
    }
  }
}

// 按钮样式
.main-btn {
  padding: 1px;
  font-size: 1.1rem;
  border-radius: 15px;
  border: none;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  position: relative;
  z-index: 2;
  overflow: visible;

  &:hover {
    &:before {
      transform: translateX(10px) !important;
      width: calc(100% + 10px);
      filter: blur(20px);
      z-index: -2;
    }
  }

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: conic-gradient(from -90deg at 50% 50%, 
      rgba(220, 255, 99, 0.6) 0deg, 
      rgba(123, 244, 226, 0.6) 20deg, 
      rgba(58, 109, 242, 0.6) 150deg, 
      rgba(255, 92, 46, 0.6) 200deg, 
      rgba(255, 190, 38, 0.6) 300deg, 
      rgba(220, 255, 99, 0.6) 360deg);
    border-radius: 15px;
    filter: blur(0px);
    z-index: -1;
    transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  }

  &.main-btn-small {
    &.sm2{
      a{
        width: 140px;
        height: 40px;
      }
    }

    a{
      font-size: 14px;
      font-weight: 600;
      width: 312px;
      height: 44px;
    }
  }

  a {
    background-color: black;
    font-size: 1.25rem;
    color: white;
    height: 78px;
    width: 238px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    border-radius: 14px;
    z-index: 2;
    text-decoration: none;
    transition: all 0.3s ease;
  }
}

// 页脚
.main-footer {
  background: #000;
  padding: 60px 20px 20px;

  .footer-container {
    max-width: 1200px;
    margin: 0 auto;
  }

  .footer-content {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 40px;
    margin-bottom: 40px;
  }

  .footer-section {
    h4 {
      font-size: 18px;
      font-weight: 700;
      color: #ffffff;
      margin: 0 0 20px;
    }

    p {
      color: #8892b0;
      line-height: 1.6;
      margin: 0 0 8px;
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        margin-bottom: 8px;

        a {
          color: #8892b0;
          text-decoration: none;
          transition: color 0.3s ease;

          &:hover {
            color: #667eea;
          }
        }
      }
    }
  }

  .footer-bottom {
    text-align: center;
    padding-top: 20px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);

    p {
      color: #8892b0;
      margin: 0;
    }
  }
}

// 响应式
@media (max-width: 768px) {
  .models-section .model-grid {
    grid-template-columns: 1fr !important;
  }

  .header-nav {
    display: none !important;
  }
}
</style>
